import React from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding } from '@fortawesome/free-regular-svg-icons'
import ClientCardHolder from '../styles/clientCardStyle'

const ClientCard = ({ client, selected, onClick }) => {
  const { t } = useTranslation()

  return (
    <ClientCardHolder className={selected ? 'selected' : ''} onClick={onClick}>
      <div className="client-info">
        <span className="client-name">{client.name}</span>
      </div>
      <div className="client-logo">
        {client.avatar ? (
          <img src={client.avatar} alt={client.name} />
        ) : (
          <FontAwesomeIcon icon={faBuilding} className="client-logo-icon" />
        )}
      </div>
    </ClientCardHolder>
  )
}

export default ClientCard
